import { connect } from 'react-redux';
import
{
	autoCompleteSelector
} from '../../../selectors';

import
{
	loadAutoComplete,
	updateAutoCompleteSelection,
	clearAutoCompleteSelection,
	hideAutoComplete,
	updateAutoCompleteQuery
} from '../../../actions';

import { findDOMNode } from 'react-dom';

var React = require('react');
var classnames = require('classnames');

var keyCodes = {
	ENTER: 13,
	UP_ARROW: 38,
	DOWN_ARROW: 40,
	ESC: 27
};

// var searchbarActive = false;

class AutoCompleteSearchForm extends React.Component {

	componentDidMount() {
		// we only need to fetch the data in the client
		this.context.store.dispatch(loadAutoComplete());
		if (this.props.query && this.props.query.searchbarActive ) {
			this._searchbarActiveInit();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.query && nextProps.query.searchbarActive && !this.props.query.searchbarActive) {
			this._searchbarActiveInit();
		}
	}

	_searchbarActiveInit(){
		this._getSearchInput().focus();
		var rect = document.getElementById("svtse_menu").getBoundingClientRect();
		var posTop = rect.top + document.body.scrollTop;
		if(posTop > 1){
			setTimeout(function(){
				window.scrollTo(0,posTop);
			}, 0);
		}
	}

	_handlerKeyDown(event) {
		// using keyDown instead of keyPress since the eventCode was sometimes 0 in chrome when using keyPress
		var key = event.keyCode;
		switch (key) {
			case keyCodes.ENTER:
				this._navigateToTitleIfSelected(event);
				break;
			default:
				break;
		}
	}

	_handlerKeyChanged(event) {
		var key = event.keyCode;

		switch (key) {
			case keyCodes.ESC:
				this._keyClear();
				this._getSearchInput().blur();
				break;
			case keyCodes.UP_ARROW:
				this._keyMove(-1);
				break;
			case keyCodes.DOWN_ARROW:
				this._keyMove(1);
				break;
			case keyCodes.ENTER:
				this._navigateToTitleIfSelected(event);
				break;
			default:
				this._updatedAutoCompleteState();
		}
	}

	_updatedAutoCompleteState() {
		var value = this._getSearchInput().value;
		this.context.store.dispatch(updateAutoCompleteQuery(value));
	}

	_navigateToTitleIfSelected(event) {
		const item = this.props.item;
		if (item && item.url) {
			event.preventDefault();
			document.location.href = item.url;
			// TODO: Use transitionTo for "internal" urls // this.context.router.transitionTo(item.target);
			this.context.store.dispatch(hideAutoComplete());
		}
	}

	_fullWidthSearchOverlay(){
		return findDOMNode( this.refs.searchForm).offsetLeft > 0;
	}

	_handlerBlurred() {
		// Only hide when not in "small" mode
		if(!this._fullWidthSearchOverlay()){
			this.context.store.dispatch(hideAutoComplete());
		}
	}

	_keyClear() {
		this.context.store.dispatch(clearAutoCompleteSelection());
	}

	_keyMove(i) {

		this.context.store.dispatch(updateAutoCompleteSelection(i));
	}

	_getSearchInput() {
		return findDOMNode(this.refs.searchInput);
	}

	componentDidUpdate() {
		if(this.props.item && this.props.item.title){
			this._getSearchInput().value = this.props.item.title;
		}
	}

	_renderAssertive() {
		const item = this.props.item;

		if(item && item.title && item.url){
			return (
				<span>{item.title}</span>
			);
		}

		if(item && item.searchTerm){
			return (
				<span>Sök {item.searchTerm} på hela SVT</span>
			);
		}

		if(this.props.count) {
			return (
				<span>{this.props.count} sökförslag visas</span>
			);
		}

		return;

	}

	render() {
		var className = classnames({
			'svtse_search-form': true
		});

		// var ariaControlsId = this.props.ariaControlsId;
		var ariaControlsId = 'svtse_a11y-auto-complete-list';
		var ariaExpanded = this.props.count ? true : false;

		return (
			<form id="svtse_accessKey--4" action="//www.svt.se/search/" method="get" className={className} ref="searchForm">

				<div role="search">

					<label className="svtse_search-form__label" htmlFor="s">Sök på hela SVT</label>

					<input id="s"
						   type="search"
						   maxLength="100"
						   name="q"
						   placeholder="Sök på SVT"
						   onKeyUp={this._handlerKeyChanged.bind(this)}
						   onKeyDown={this._handlerKeyDown.bind(this)}
						   onBlur={this._handlerBlurred.bind(this)}
						   className="svtse_search-form__input"
						   ref="searchInput"
						   autoCorrect="off"
						   autoComplete="off"
						   accessKey="4"
						   aria-haspopup="true"
						   aria-controls={ariaControlsId}
						   aria-expanded={ariaExpanded}
					/>

					<div className="svtse_a11y-hidden" aria-live="assertive">{this._renderAssertive()} </div>

					<div></div>

					<button type="submit" className="svtse_search-form__btn" aria-label="Sök" ref="searchBtn">
						<span className="svtse_search-form__btn-icon svtse_search-form__btn-icon--search" aria-hidden="true"></span>
					</button>
				</div>

			</form>
		);
	}
}

AutoCompleteSearchForm.propTypes = {
		model: React.PropTypes.shape({
			titleList: React.PropTypes.arrayOf(React.PropTypes.shape({})).isRequired,
			selectedIndex: React.PropTypes.number.isRequrired,
			searchQuery: React.PropTypes.string.isRequrired,
			slim: React.PropTypes.bool
		})
};

AutoCompleteSearchForm.contextTypes = {
	store: React.PropTypes.object.isRequired,
};

function select(state) {
	const item = autoCompleteSelector(state).get('selected');
	return {
		ariaControlsId: React.PropTypes.string.isRequired,
		item: item?item.toJS():null,
		count: autoCompleteSelector(state).get('count')
	};
}

export default connect(select)(AutoCompleteSearchForm);



/** WEBPACK FOOTER **
 ** ./app/components/menu/search/AutoCompleteSearchForm.jsx
 **/